<div class="force-update-container">
  <div class="force-update-card">
    <ion-icon name="cloud-download-outline" class="force-update-icon"></ion-icon>
    <h2>Update Required</h2>
    <p>
      A new version of this app is available. Please update to continue using
      the application.
    </p>
    <ion-button
      color="primary"
      mode="ios"
      expand="block"
      (click)="update()">
      Update
    </ion-button>
  </div>
</div>
